import { useStytch } from '@stytch/nextjs';
import { useEffect, useRef } from 'react';

import { SESSION_DURATION_MINUTES, SESSION_REFRESH_INTERVAL } from 'pages/authenticate';

// from https://stytch.com/docs/sdks/javascript-sdk#session-management_methods_refresh
export const RefreshSession = () => {
  const stytchClient = useStytch();
  const maxRefreshes = 50;
  // Use ref to avoid recreating interval on every refresh count change
  const refreshCountRef = useRef(0);

  useEffect(() => {
    const refresh = () => {
      if (stytchClient.session.getSync() && refreshCountRef.current < maxRefreshes) {
        console.info('refreshing session!');
        stytchClient.session.authenticate({
          session_duration_minutes: SESSION_DURATION_MINUTES,
        });
        refreshCountRef.current += 1;
      }
    };
    // Refresh session at intervals to reduce chances of the user being in the middle of a flow
    // when refresh occurs because the state of the app gets reset forcing the user to go through that flow again
    const interval = setInterval(refresh, SESSION_REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [stytchClient]);

  return null;
};
